import { render, staticRenderFns } from "./PlanejamentoContratoModalCategoriaFornecedor.vue?vue&type=template&id=0a46a317"
import script from "./PlanejamentoContratoModalCategoriaFornecedor.vue?vue&type=script&lang=js"
export * from "./PlanejamentoContratoModalCategoriaFornecedor.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoContratoModalCategoriaFornecedor.vue?vue&type=style&index=0&id=0a46a317&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports